<template>
  <div>
    <mdb-spinner v-if="showSpinner"/>
    <div v-if="!showSpinner">
      <mdb-row>
        <mdb-col md="3" v-bind:key="image.id" v-for="image in images">
          <mdb-card class="mb-4">
            <mdb-view class="zoom">
              <a @click="selectImage(image)" role="button">
                <mdb-card-image :src="image.thumbUrl"></mdb-card-image>
                <mdb-mask overlay="white-slight" waves/>
              </a>
            </mdb-view>
          </mdb-card>
        </mdb-col>
      </mdb-row>
      <mdb-pagination circle v-if="pages>1">
        <mdb-page-item @click.native="navTo(1)" v-if="pages > 10 && pageRange[0] != 1">First</mdb-page-item>
        <mdb-page-item :active="n == currentPage" @click.native="navTo(n)" v-bind:key="n" v-for="n in pageRange">{{n}}
        </mdb-page-item>
        <mdb-page-item @click.native="navTo(pages)" v-if="pages > 10 && pageRange[9] != pages">Last</mdb-page-item>
      </mdb-pagination>
    </div>
  </div>
</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import error from '../common/Error'
import mdbFileUpload from 'mdbvue-file-upload'
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardImage,
  mdbCol,
  mdbIcon,
  mdbInput,
  mdbMask,
  mdbPageItem,
  mdbPagination,
  mdbRow,
  mdbSpinner,
  mdbView
} from 'mdbvue';

export default {
    name: "SystemImageSelector",
    display: "System Image Browser",
    order: 1,
    props: {
      emitOnSelection: {
        type: String,
        default: null
      }
    },
    components: {
      mdbBtn,
      mdbRow,
      mdbCol,
      mdbCard,
      mdbCardHeader,
      mdbCardImage,
      mdbMask,
      mdbIcon,
      mdbView,
      mdbSpinner,
      mdbCardBody,
      mdbFileUpload,
      mdbInput,
      mdbPagination,
      mdbPageItem,
      error
    },
    mounted() {
      this.showSpinner = true
      this.loadImages()
    },
    data() {
      return {
        images: [],
        error: null,
        showSpinner: false,
        offset: 0,
        total: 0,
        pageRange: [],
        pages: 0,
        currentPage: 1,
        maxPerPage: 25
      };
    },
    methods: {
      selectImage: function (image) {
        this.$emit(this.emitOnSelection, image)
      },
      loadImages: function() {
        let url = "/admin/images"
        if (this.offset > 0) url += "?offset=" + this.offset
        api.get(url, {}).then(
          (details) => {
            this.images = details.data.images
            this.total = details.data.total
            this.calculatePagination()
          },
          (error) => {
            this.$notify.error({message: "Error getting images."})
          }).then(() => {
          this.showSpinner = false
        })
      },
      calculatePagination : function() {
        if (this.pages == 1) return
        this.pageRange = []
        if (this.total <= this.maxPerPage) this.pages = 1
        else {
          this.pages = Math.round(this.total / this.maxPerPage)
          if ( (this.pages*25) < this.total ) this.pages++
        }
        let rangeStart = 0
        if (this.pages <= 10) {
          rangeStart = 1
        } else {
          rangeStart = this.currentPage - 1
          if (rangeStart + 10 > this.pages) rangeStart = this.pages - 9
        }
        if (rangeStart < 1) rangeStart = 1
        let max = (this.pages > 10 ? 10 : this.pages)
        for (let i = 0; i < max; i++) {
          const p = i + rangeStart
          if (p <= this.pages) this.pageRange.push(p)
        }
      },
      navTo : function(n) {
        this.currentPage = n
        this.offset = (n - 1) * 25
        this.loadImages()
      }

    }
  };
</script>
